import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AreaHasUserService } from "../../master-services/AreaHasUser-services/AreaHasUser.service";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { AreasService } from "../../master-services/area-services/areas.service";
import { UserService } from "../../master-services/User/user.service";
import { ChecklisAreatService } from "../../master-services/check-list/checklistArea.service";
import swal from "sweetalert2";
import { Console, error } from "console";

@Component({
  selector: "app-master-area",
  templateUrl: "./master-area-manage.component.html",
  styleUrls: ["./master-area-manage.component.scss"],
})
export class MasterAreaManageComponent implements OnInit {
  //(i) usuario en el aria
  areaId: any;
  users: any;
  userSelects: any;
  areaName: string;
  userForm: FormGroup;
  // (f)usuario en el aria

  // (i) listas de chequeo
  checklists: any;
  checklistForm: FormGroup;

  // (f) listas de chequeo

  constructor(
    private router: Router,
    private rutaActiva: ActivatedRoute,
    private AreaHasUserService: AreaHasUserService,
    private AreasService: AreasService,
    private UserService: UserService,
    private ChecklisAreatService: ChecklisAreatService
  ) {
    this.areaId = Number(localStorage.getItem("idarea"));

    //*********** (i) Administra usuario en el aria  *************** */
    this.nameArea(this.areaId);
    this.listAreaManager(this.areaId);
    this.getUser();
    const id = new FormControl("0");
    const userId = new FormControl("", Validators.required);
    this.userForm = new FormGroup({
      id: id,
      userId: userId,
    });
    //*********** (f) // Administra usuario en el aria  *************** */

    //*********** (i) Administrar listas de chequeo  *************** */
    const idlist = new FormControl("0");
    const nameList = new FormControl("", Validators.required);
    const description = new FormControl("");
    this.indexByIdArea(this.areaId);
    this.checklistForm = new FormGroup({
      idlist: idlist,
      nameList: nameList,
      description: description,
    });

    //*********** (f) Administrar listas de chequeo  *************** */
  }
  ngOnInit() {}

  //*********** (i) Administra usuario en el aria  *************** */
  //Lista de usuarios select
  getUser() {
    this.UserService.getUsers()
      .then((data) => {
        const resp: any = data;
        this.userSelects = resp.data;
      })
      .catch((error) => {
        // console.log(error);
      });
  }
  //Agregar usuario al aria de trabajo
  addAreaUser() {
    console.log(
      "user:" + this.userForm.get("userId").value,
      "id:" + this.userForm.get("id").value,
      "area :" + Number(this.areaId)
    );
    if (!this.userForm.invalid) {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();

      this.AreaHasUserService.strageAreaUser(
        Number(this.userForm.get("id").value),
        Number(this.userForm.get("userId").value),
        Number(this.areaId)
      )
        .then((data) => {
          const resp: any = data;
          console.log(resp);

          if (resp.success === false) {
            swal({
              title: "Mensaje ",
              text: "El usuario, ya tiene un grupo ",
              type: "error",
            });

            console.log(resp.message);
          } else {
            swal({
              title: "Tercero agregado",
              type: "success",
              text: resp.message,
            });
          }
        })
        .catch((error) => {
          // console.log(error);
        });
    }
    this.listAreaManager(this.areaId);
  }
  //Genera el nombre del área
  nameArea(id) {
    this.AreasService.getAreaName(id)
      .then((data) => {
        const resp: any = data;
        this.areaName = resp.data;
      })
      .catch((error) => {
        // console.log(error);
      });
  }
  //Genera el listado de los usuarios relacionados al área
  listAreaManager(id) {
    this.AreaHasUserService.getArea(id)
      .then((data) => {
        const resp: any = data;
        this.users = resp.data;
        console.log(this.users);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  //Cambia al estado del usuario
  delete(id) {
    this.AreaHasUserService.delete(id)
      .then((data) => {
        const resp: any = data;
        console.log(resp);
        this.listAreaManager(this.areaId);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  //*********** (f) Administra usuario en el aria  *************** */

  //*********** (i) Administrar listas de chequeo  *************** */

  indexByIdArea(id: number) {
    this.ChecklisAreatService.indexByIdArea(id)
      .then((data) => {
        const resp: any = data;
        this.checklists = resp.data;
        console.log(this.checklists);
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  checklistFormClear() {
    this.checklistForm.get("idlist").setValue("0");
    this.checklistForm.get("nameList").setValue("");
    this.checklistForm.get("description").setValue("");
  }

  createchecklist() {
    if (!this.checklistForm.invalid) {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();
      this.ChecklisAreatService.createchecklist(
        Number(this.checklistForm.get("idlist").value),
        this.checklistForm.get("nameList").value,
        this.checklistForm.get("description").value,
        Number(this.areaId)
      )
        .then((data) => {
          const resp: any = data;

          if (resp.success === false) {
            console.log(resp.message);
            swal({
              title: "Mensaje ",
              text: resp.message.nameList,
              type: "error",
            });
          } else {
            swal({
              title: "Tercero agregado",
              type: "success",
              text: resp.message,
            });
          }
        })
        .catch((error) => {
          // console.log(error);
        });
    }
    this.checklistFormClear();
    this.indexByIdArea(this.areaId);
  }

  deleteList(id: number) {
    this.ChecklisAreatService.recoverDeleteList(id).then((data) => {
      const resp: any = data;
      console.log(resp.message);
      this.indexByIdArea(this.areaId);
    });
  }

  automaticForm(data: any) {
    alert("hola");
    this.checklistForm.get("idlist").setValue(data.id);
    this.checklistForm.get("nameList").setValue(data.name_list);
    this.checklistForm.get("description").setValue(data.description);
  }

  getListId(id: number) {
    this.ChecklisAreatService.checkListById(id).then((data) => {
      const resp: any = data;

      console.log(resp.data);

      this.checklistForm.get("idlist").setValue(resp.data[0].id);
      this.checklistForm.get("nameList").setValue(resp.data[0].name_list);
      this.checklistForm.get("description").setValue(resp.data[0].description);
    });
  }

  ToquestionsCheck(id) {
    this.router.navigateByUrl("erp/grupoLista/" + id);
    localStorage.setItem("lisChek", id);
  }

  //***********  (f)  Administrar listas de chequeo  *************** */
}



// WEBPACK FOOTER //
// ./src/app/master/master-area-manage/master-area-manage.component.ts